<template>
  <div id="body">
    <div class="title">
      <i class="bi bi-journal-check"> </i> 历史查询
    </div>

    <div class="top">
      <div class="top-item">历史查询报告记录</div>
      <div class="block">
        <span class="demonstration">月</span>
        <el-date-picker v-model="date" type="month" size="small" clearable placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
      </div>
      <div>
        <el-input v-model="drivingId" placeholder="请输入VIN号" clearable size="small" class="searchItem"></el-input>
        <el-button type="primary" size="small" @click="searchTop()" style="margin-left: 5%">
          查询
        </el-button>
      </div>
    </div>

    <el-collapse v-infinite-scroll="load"
                 :infinite-scroll-immediate="false"
                 :infinite-scroll-disabled="disabled"
                 v-model="activeNames"
                 @change="handleChange"
                 accordion
                 style="margin: 0 auto; width: 97%; margin-top: 10px;">
      <el-collapse-item :name="index" v-for="(order, index) in orders" :key="index">
        <div slot="title" v-if="order.idDeal == 0" style="font-size: 12px;">
          &nbsp;&nbsp;&nbsp;&nbsp;
          {{ order.drivingId }}
          &nbsp;&nbsp;&nbsp;&nbsp;
          {{ order.createTime }}
          &nbsp;&nbsp;&nbsp;&nbsp;
          <img src="../assets/wei.png" style="width: 30px; height: 30px;" >
        </div>

        <div slot="title" v-else style="font-size: 12px;">
          &nbsp;&nbsp;&nbsp;&nbsp;
          {{ order.drivingId }}
          &nbsp;&nbsp;&nbsp;&nbsp;
          {{ order.createTime }}
          &nbsp;&nbsp;&nbsp;&nbsp;
          <img src="../assets/yi.png" style="width: 30px; height: 30px;">
        </div>
        <!--        <template slot="title" v-if="order.idDeal == 0">
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ order.drivingId }}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ order.createTime }}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <img src="../assets/wei.png" style="width: 30px; height: 30px;">
                </template>

                <template slot="title" v-else>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ order.drivingId }}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {{ order.createTime }}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <img src="../assets/yi.png" style="width: 30px; height: 30px;">
                </template>-->
        <el-descriptions class="margin-top" direction="vertical" :column="2" size="mini" border
                         style="margin-bottom: -7%;">
          <el-descriptions-item>
            <template slot="label">
              车辆所有人
            </template>
            {{ order.carAll }}
          </el-descriptions-item>
<!--          <el-descriptions-item>
            <template slot="label">
              车牌号
            </template>
            {{ order.carCode }}
          </el-descriptions-item>-->
          <el-descriptions-item>
            <template slot="label">
              行驶证号码
            </template>
            {{ order.drivingId }}
          </el-descriptions-item>
<!--          <el-descriptions-item>
            <template slot="label">
              订单编号
            </template>
            {{ order.number }}
          </el-descriptions-item>-->

          <el-descriptions-item>
            <template slot="label">
              电子签名
            </template>
            <el-image style="width: 80px; height: 80px" :src="order.autograph" :preview-src-list="srcList"
                      @click="dzqm(order)" />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              行驶证图片
            </template>
            <el-image style="width: 80px; height: 80px" :src="order.drivingLicense"
                      :preview-src-list="srcList" @click="xsz(order)">
            </el-image>
          </el-descriptions-item style="width: 33.3%;">
          <el-descriptions-item>
            <template slot="label">
              查询时间
            </template>
            {{ order.createTime }}
          </el-descriptions-item>
          <el-descriptions-item v-if="order.idDeal == 0">
            <template slot="label">
              查询结果详情
            </template>
            <el-button type="primary" size="small" @click="searchOrder(order)" v-show="show">
              查看报告
            </el-button>
            <el-button type="primary" size="small" v-show="!show" disabled>
              <i class="el-icon-loading"></i>
              加载中..
            </el-button>
          </el-descriptions-item>
          <el-descriptions-item v-if="order.idDeal == 1">
            <template slot="label">
              查询结果详情
            </template>
            <div>该报告已过期</div>
          </el-descriptions-item>
        </el-descriptions>

      </el-collapse-item>
    </el-collapse>

    <div>
      <p v-if="loading" style="background-color: #f5f5f5; margin-top: 10px; text-align: center;">
        <i class="el-icon-loading"></i>加载中...
      </p>
      <p v-if="noMore" style="background-color: #f5f5f5; margin-top: 15px; text-align: center;">
        <i class="el-icon-bell"></i> 没有更多记录了
      </p>
    </div>

    <el-empty description="暂无记录" id="item" v-if="orders.length==0"></el-empty>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ['1'],
      date: '',
      dateNo: '',
      drivingId: '',
      userId: '',
      srcList: [],
      orders: [],
      isNull: true,
      loading1: false,
      show: true,
      maintenanceShow: true,

      page: 0, //起始页数
      loading: false,
      total: "", //总页数
      noMore: false,
      limit: 20,
      disabledGet: true
    };
  },
  computed: {
    disabled() {
      return this.loading
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if(this.disabledGet){
          this.noMore = false
          this.loading = true
          this.disabledGet = false
          this.page += this.limit
          this.search()
        }
      }, 1500)
    },
    searchTop(){
      this.page = 0
      this.limit = 20
      this.orders = []
      if(this.date == undefined){
        this.dateNo = "2000-01"
      }
      this.search()
    },
    search() {
      if(this.date != undefined){
        this.$api({
          method: 'get',
          url: '/mobileLogin/getOrderHistory?userId=' + this.userId + '&isDate=' + this
              .date + '&page=' + this.page + '&size=' + this.limit + "&drivingId=" + this.drivingId
        }).then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.orders = this.orders.concat(res.data.data); //因为每次后端返回的都是数组，所以这边把数组拼接到一起
              this.total = res.data.total;

              if(res.data.data.length==this.limit){
                this.loading = false
                this.disabledGet = true
              }
              if(res.data.data.length<this.limit){
                this.loading = false
                this.noMore = true
              }
            },500)
          }
        })
      }else{
        this.$api({
          method: 'get',
          url: '/mobileLogin/getOrderHistory?userId=' + this.userId + '&isDate=' + this
              .dateNo + '&page=' + this.page + '&size=' + this.limit + "&drivingId=" + this.drivingId
        }).then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.orders = this.orders.concat(res.data.data); //因为每次后端返回的都是数组，所以这边把数组拼接到一起
              this.total = res.data.total;

              if(res.data.data.length==this.limit){
                this.loading = false
                this.disabledGet = true
              }
              if(res.data.data.length<this.limit){
                this.loading = false
                this.noMore = true
              }
            },1500)
          }
        })
      }

    },

    searchOrder(order) {
      this.show = false
      this.$api({
        method: 'post',
        url: '/mobileLogin/doQuery',
        params: {
          orderno: order.number
        }
      }).then(res => {
        this.loading1 = true
        this.$router.push("/openOrder?orderno=" + order.number + "&ordertype=1" + "&vin=" + order.drivingId + "&render=" + Math.round(Math.random()*80+20))
        //window.location.replace(res.data)
      })
    },

    dzqm(order) {
      this.srcList = []
      this.srcList.push(order.autograph)
    },
    xsz(order) {
      this.srcList = []
      this.srcList.push(order.drivingLicense)
    },
    handleChange(val) {

    },
    addDate() {
      let nowDate = new Date()
      let date = {
        year: nowDate.getFullYear(),
        //month: nowDate.getMonth() + 1,//这样写小于10的月份会没有0
        month: (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date()
            .getMonth() + 1),
        date: nowDate.getDate()
      }
      this.date = date.year + '-' + date.month
    }


  },
  created() {
    this.userId = localStorage.getItem('userId');
    this.addDate()
    this.searchTop()
  },
  destroyed() {
    this.loading1 = false
  }
};
</script>


<style scoped>
.hei {
  color: #000000;
}

.top {
  background-color: #FFFFFF;
  width: 97%;
  margin: 0 auto;
  padding-top: 0.425rem;
  padding-bottom: 0.425rem;
}

.top-item {
  height: 10%;
  margin: 0 auto;
  font-size: 20px;
  color: #0062CC;
  width: 90%;
}

#item {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5375rem;
  border-radius: 50%;
  margin-bottom: 0.25rem;
}

#type {
  font-size: 0.825rem;
  margin-left: 0.5rem;
  border-radius: 10%;
  background-color: #138496;
  color: #FFFFFF;
}

#status {
  float: right;
  color: #138496;
  font-size: 0.825rem;
  margin-right: 1.0125rem;
}

#content {
  background-color: #FFFFFF;
  border-radius: 3%;
  width: 95%;
  height: 7.9rem;
  margin: 0 auto;
}

#content-top {
  display: flex;
  margin-left: 0.5rem;
  padding-top: 0.625rem;
}

#name {
  padding-left: 1.05rem;
}

#content-bot {
  display: block;
  margin-left: 0.5rem;
  padding-top: 0.625rem;
}

#time {
  color: #138496;
  font-size: 0.825rem;
}

#money {
  float: right;
  font-size: 0.825rem;
  /* margin-left: 12.5125rem; */

}

img {
  width: 4.25rem;
  height: 4.25rem;
  border-radius: 5%;
}

.searchItem{
  width: 58%;
  margin-left: 4%;
  margin-top: 2%;
}
</style>